






































































































































































































































































import { Vue, Component, InjectReactive } from 'vue-property-decorator';
import dayjs from 'dayjs';
import { inject } from 'inversify-props';
import { AgGridVue } from '@ag-grid-community/vue';
import {
  SelectionChangedEvent,
  GridReadyEvent,
  ValueGetterParams,
  ValueFormatterParams,
} from '@ag-grid-community/core';
import { isArray, sortBy } from 'lodash';
import { plainToClass } from 'class-transformer';
import DateRangeFilter from '@/components/date-range-filter.vue';
import { IDateRangeConfig } from '@/interfaces/date-range-config.interface';
import Tooltip from '@/components/tooltip.vue';
import DataGridFilter from '@/components/data-grid-filter.vue';
import { InjectionIdEnum } from '@/enums/injection-id.enum';
import RouterService from '@/services/router.service';
import SettingsService from '@/services/crm/settings.service';
import SettingsModel from '@/models/crm/settings.model';
import ContentDialog from '@/components/content-dialog.vue';
import { DateHelper } from '@/utils/helpers/date-helper';
import ClientModel from '@/models/crm/client.model';
import AgGridWrapper from '@/components/ag-grid-wrapper.vue';
import { IGridCellEvent } from '@/interfaces/grid-cell-clicked.interface';
import { IGridConfig } from '@/interfaces/grid-config.interface';
import { GridHelper } from '@/utils/helpers/grid-helper';
import { IKeyValue } from '@/interfaces/key-value.interface';
import { IDialogConfig } from '@/interfaces/dialog-config.interface';
import ConversationService from '@/services/crm/conversation.service';
import HistoryTypeModel from '@/models/crm/history-type.model';
import AttendanceModel from '@/models/crm/attendance.model';
import ConversationDepartmentModel from '@/models/crm/conversation-department.model';
import UserModel from '@/models/user.model';
import ActivityService from '@/services/crm/activity.service';
import ConversationModel from '@/models/crm/conversation.model';
import { ClientTypeEnum } from '@/enums/client-type.enum';
import ContactModel from '@/models/crm/contact.model';
import ContactService from '@/services/crm/contact.service';
import CrmChatHistoryMessagesViewer from '../../components/crm/chat-history-messages-viewer.vue';
import ConversationTemplateModel from '@/models/crm/conversation-template.model';

type DataGridFilterConfig = {
  client: string[] | null;
  prospect: number[] | null;
  periodType: PeriodTypeEnum;
  period: (Date | undefined)[];
  status: StatusEnum | null;
  department: ConversationDepartmentModel[] | null;
  attendant: AttendanceModel[] | null;
  originType: OriginTypeEnum[] | null;
  template: ConversationTemplateModel[] | null;
  historyType: HistoryTypeModel[] | null;
  protocolNumber: string | null;
  contact: ContactModel[] | null;
};

enum PeriodTypeEnum {
  OpenDate = 'OPEN_DATE',
  StartDate = 'START_DATE',
  ClosingDate = 'CLOSING_DATE',
}

enum StatusEnum {
  Open = 'OPEN',
  Closed = 'CLOSED',
}

enum OriginTypeEnum {
  Active = 2,
  Receptive = 1,
}

interface ISelectOption<T> {
  code: T;
  description: string;
}

@Component({
  components: {
    DataGridFilter,
    DateRangeFilter,
    Tooltip,
    AgGridWrapper,
    AgGridVue,
    ContentDialog,
    CrmChatHistoryMessagesViewer,
  },
})
export default class CrmOrders extends Vue {
  @inject(InjectionIdEnum.CrmSettingsService)
  private settingsService!: SettingsService;

  @inject(InjectionIdEnum.CrmContactService)
  private contactService!: ContactService;

  @inject(InjectionIdEnum.RouterService)
  private routerService!: RouterService;

  @inject(InjectionIdEnum.CrmActivityService)
  private activityService!: ActivityService;

  @inject(InjectionIdEnum.CrmConversationService)
  private conversationService!: ConversationService;

  @InjectReactive('activeClient') readonly activeClient!: ClientModel;

  @InjectReactive('clientType') readonly clientType!: ClientTypeEnum;

  private settings!: SettingsModel;

  grid: GridReadyEvent | null = null;

  gridSettings: IGridConfig = {
    loading: false,
    defaultSort: [{ colId: 'dataUltimaMensagem', sort: 'desc' }],
    columnDefs: [
      GridHelper.getSelectionColDef(),
      {
        headerName: `${this.$t('crm.view.chatReport.grid.openDate')}`,
        colId: 'openDate',
        field: 'dataInclusao',
        minWidth: 130,
        maxWidth: 130,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const date = params.data.dataInclusao;
          return DateHelper.formatToIsoDateTimeString(date);
        },
        valueFormatter: (params: ValueFormatterParams): string => {
          if (params.value && params.value !== 'Invalid Date') {
            return DateHelper.formatToLocale(params.value, 'dateTime');
          }
          return '';
        },
        cellClass: 'dateISO',
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.startDate')}`,
        colId: 'startDate',
        field: 'dataInicio',
        minWidth: 150,
        maxWidth: 150,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const date = params.data.dataInicio;
          return DateHelper.formatToIsoDateTimeString(date);
        },
        valueFormatter: (params: ValueFormatterParams): string => {
          if (params.value && params.value !== 'Invalid Date') {
            return DateHelper.formatToLocale(params.value, 'dateTime');
          }
          return '';
        },
        cellClass: 'dateISO',
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.closeDate')}`,
        colId: 'closeDate',
        field: 'dataFechamento',
        minWidth: 130,
        maxWidth: 130,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const date = params.data.dataFechamento;
          return DateHelper.formatToIsoDateTimeString(date);
        },
        valueFormatter: (params: ValueFormatterParams): string => {
          if (params.value && params.value !== 'Invalid Date') {
            return DateHelper.formatToLocale(params.value, 'dateTime');
          }
          return '';
        },
        cellClass: 'dateISO',
      },
      {
        headerName: `${this.$t('crm.view.chats.grid.lastAttendance')}`,
        colId: 'lastAttendance',
        field: 'dataUltimaMensagem',
        minWidth: 130,
        maxWidth: 130,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const date = params.data.dataUltimaMensagem || params.data.dataInicio || params.data.dataInclusao;
          return DateHelper.formatToIsoDateTimeString(date);
        },
        valueFormatter: (params): string => DateHelper.formatToLocale(params.value, 'dateTime'),
        cellClass: 'dateISO',
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.originType')}`,
        colId: 'OriginType',
        field: 'origemConversa',
        minWidth: 120,
        maxWidth: 120,
        sortable: false,
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.template')}`,
        colId: 'Template',
        field: 'templateConversa',
        minWidth: 210,
        sortable: false,
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.cellPhone')}`,
        colId: 'cellphone',
        field: 'numeroWhatsapp',
        minWidth: 120,
        maxWidth: 120,
        flex: 0.8,
        sortable: false,
      },
      {
        headerName: `${this.$t('crm.view.chats.grid.contactName')}`,
        colId: 'contactName',
        field: 'contato.nome',
        minWidth: 150,
        flex: 0.8,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const isRowPinned = params.node && params.node.rowPinned;
          if (!isRowPinned) {
            return params.data?.contato?.nome || params.data.numeroWhatsapp;
          }
          return '';
        },
      },
      {
        headerName: `${this.$t('crm.view.chats.grid.protocol')}`,
        colId: 'protocol',
        field: 'protocolo',
        minWidth: 160,
        maxWidth: 160,
        cellClass: 'cell-grid-link',
        sortable: true,
      },
      {
        headerName: `${this.$t('crm.view.chats.grid.attendant')}`,
        colId: 'attendant',
        field: 'atendente.nome',
        minWidth: 120,
        flex: 0.5,
        sortable: true,
      },
      {
        headerName: `${this.$t('crm.view.chats.grid.department')}`,
        colId: 'department',
        field: 'departamento.nome',
        minWidth: 120,
        flex: 0.5,
        sortable: true,
      },
      {
        headerName: `${this.$t('crm.view.chats.grid.historyType')}`,
        colId: 'historyType',
        field: 'tipoHistorico.nome',
        minWidth: 150,
        flex: 0.8,
        sortable: true,
      },
    ],
  };

  items: ConversationModel[] = [];

  itemsProspect: ConversationModel[] = [];

  selected: ConversationModel[] = [];

  // #region filters

  predefinedPeriodRanges: IDateRangeConfig[] = this.getDateRanges();

  multipleFilterChanged = false;

  filters: DataGridFilterConfig = {
    client: null,
    prospect: null,
    periodType: PeriodTypeEnum.OpenDate,
    period: [dayjs().startOf('year').toDate(), dayjs().toDate()],
    status: null,
    department: null,
    attendant: null,
    originType: [OriginTypeEnum.Active, OriginTypeEnum.Receptive],
    template: null,
    historyType: null,
    protocolNumber: null,
    contact: null,
  };

  periodTypeOptions: ISelectOption<PeriodTypeEnum>[] = [];

  statusOptions: ISelectOption<StatusEnum>[] = [];

  departmentOptions: ConversationDepartmentModel[] = [];

  contactOptions: ContactModel[] = [];

  attendantOptions: UserModel[] = [];

  originTypeOptions: ISelectOption<OriginTypeEnum>[] = [];

  templateOptions: ConversationTemplateModel[] = [];

  historyTypeOptions: HistoryTypeModel[] = [];

  loadingChats = false;

  // #endregion

  dialogConfig: IKeyValue<IDialogConfig> = {
    history: {
      show: false,
      conversation: null,
    },
    prospectChats: {
      show: false,
    },
  };

  async mounted(): Promise<void> {
    const loader = this.$loading.show();
    try {
      this.settings = await this.settingsService.getSettings();
      await this.loadFilterOptions();
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      loader.hide();
    }

    if (this.isProspectType) {
      this.filters.prospect = [parseInt(this.getClientIdFromRoute(), 10)];
    } else {
      this.filters.client = [this.getClientIdFromRoute()];
    }

    this.loadItems();
  }

  onFilterChange(type: string): void {
    if (type === 'multiple' && !this.multipleFilterChanged) {
      return;
    }

    this.multipleFilterChanged = false;
    this.loadItems();
  }

  async onCellClick(event: IGridCellEvent<ConversationModel>): Promise<void> {
    if (!event.data || event?.colDef?.colId !== 'protocol') {
      return;
    }

    this.openHistoryConversationDialog(plainToClass(ConversationModel, event.data));
  }

  openHistoryConversationDialog(conversation: ConversationModel): void {
    if (!conversation) {
      return;
    }

    this.dialogConfig.history.show = true;
    this.dialogConfig.history.conversation = conversation;
  }

  onCloseHistoryDialogClose(): void {
    this.dialogConfig.history.show = false;
    this.dialogConfig.history.conversation = false;
  }

  onSelectionChanged(change: SelectionChangedEvent, selected: ConversationModel[]): void {
    this.selected = selected;
  }

  onExport(selected: ConversationModel[]): void {
    if (this.grid) {
      const onlySelected = !!selected.length && this.items.length !== selected.length;
      const columnKeys = this.gridSettings.columnDefs
        .filter((x) => !x.checkboxSelection)
        .map((x) => x.colId || x.field || '');

      this.grid.api.exportDataAsExcel({
        onlySelected,
        columnKeys,
        allColumns: true,
        author: 'IBtech',
        sheetName: 'Conversas',
        fileName: ConversationService.generateConversationReportExportFilename(new Date()),
      });
    }
  }

  get activeFilters(): number {
    let active = 0;
    const filtersToIgnore = ['periodType'];
    const filterKeys = Object.keys(this.filters);

    filterKeys.forEach((key) => {
      const filter = this.filters[key];
      switch (key) {
        default:
          if (!filtersToIgnore.includes(key) && filter && !(isArray(filter) && !filter.length)) {
            active += 1;
          }
      }
    });

    return active;
  }

  get viewTitle(): string {
    return this.$t('crm.view.chats.title', { clientType: this.$t(`crm.${this.clientType}`) }).toString();
  }

  get historyDialogTitle(): string {
    const protocol = (this.dialogConfig.history.conversation as ConversationModel)?.protocolo;
    return this.$t('crm.view.chats.dialog.history.title', { protocol }).toString();
  }

  get isProspectType(): boolean {
    return this.clientType === ClientTypeEnum.Prospect;
  }

  private async loadItems(): Promise<void> {
    this.gridSettings.loading = true;
    // this.items = await this.orderService.getOrders(this.getClientIdFromRoute());
    this.items = (
      await this.conversationService.queryConversations(
        1,
        999,
        this.filters as unknown,
        // orderBy,
      )
    ).results;
    this.gridSettings.loading = false;
  }

  private async loadFilterOptions(): Promise<void> {
    this.periodTypeOptions = this.getPeriodTypes();
    this.statusOptions = this.getStatusOptions();
    this.originTypeOptions = this.getOriginTypeOptions();

    const tasks = [
      this.getDepartments().then((result) => {
        this.departmentOptions = result;
      }),
      this.getAttendants().then((result) => {
        this.attendantOptions = result;
      }),
      this.getTemplates().then((result) => {
        this.templateOptions = result;
      }),
      this.getHistoryTypes().then((result) => {
        this.historyTypeOptions = result;
      }),
      this.getContacts().then((result) => {
        this.contactOptions = result;
      }),
    ];

    await Promise.all(tasks);
  }

  private async loadProspectChats(): Promise<void> {
    this.dialogConfig.prospectChats.show = true;
    this.loadingChats = true;
    this.filters.client = null;
    if (this.activeClient.prospectId) {
      this.filters.prospect = [this.activeClient.prospectId];
    }
    try {
      if (this.itemsProspect.length === 0) {
        this.itemsProspect = (
          await this.conversationService.queryConversations(
            1,
            999,
            this.filters as unknown,
            // orderBy,
          )
        ).results;
      }
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      this.loadingChats = false;
      if (this.isProspectType) {
        this.filters.prospect = [parseInt(this.getClientIdFromRoute(), 10)];
      } else {
        this.filters.client = [this.getClientIdFromRoute()];
      }
    }
  }

  private getPeriodTypes(): ISelectOption<PeriodTypeEnum>[] {
    return [
      {
        code: PeriodTypeEnum.OpenDate,
        description: this.$t('crm.view.chats.filter.openDate').toString(),
      },
      {
        code: PeriodTypeEnum.StartDate,
        description: this.$t('crm.view.chats.filter.startDate').toString(),
      },
      {
        code: PeriodTypeEnum.ClosingDate,
        description: this.$t('crm.view.chats.filter.closingDate').toString(),
      },
    ];
  }

  private getStatusOptions(): ISelectOption<StatusEnum>[] {
    return [
      {
        code: StatusEnum.Open,
        description: this.$t('crm.view.chats.filter.open').toString(),
      },
      {
        code: StatusEnum.Closed,
        description: this.$t('crm.view.chats.filter.closed').toString(),
      },
    ];
  }

  private async getDepartments(): Promise<ConversationDepartmentModel[]> {
    return this.conversationService.getDepartments();
  }

  private async getAttendants(): Promise<UserModel[]> {
    return this.activityService.getAttendants();
  }

  private async getContacts(): Promise<ContactModel[]> {
    return this.contactService.getContacts(
      this.getClientIdFromRoute(),
      this.clientType,
      this.settings.flagPermiteClientesSituacao99Crm360,
    );
  }

  private getOriginTypeOptions(): ISelectOption<OriginTypeEnum>[] {
    return [
      {
        code: OriginTypeEnum.Active,
        description: this.$t('crm.view.chatReport.filter.activeConversation').toString(),
      },
      {
        code: OriginTypeEnum.Receptive,
        description: this.$t('crm.view.chatReport.filter.receptiveConversation').toString(),
      },
    ];
  }

  private async getTemplates(): Promise<ConversationTemplateModel[]> {
    return sortBy(await this.conversationService.getTemplates(), 'waTemplateName');
  }

  private async getHistoryTypes(): Promise<HistoryTypeModel[]> {
    return sortBy(await this.activityService.getHistoryTypes(), 'nome');
  }

  private getDateRanges(): IDateRangeConfig[] {
    return [
      {
        name: `${this.$t('global.today')}`,
        ...DateHelper.getTodayPeriod(),
      },
      {
        name: `${this.$t('global.yesterday')}`,
        ...DateHelper.getYesterdayPeriod(),
      },
      {
        name: `${this.$t('global.currentMonth')}`,
        ...DateHelper.getCurrentMonthPeriod(),
      },
      {
        name: `${this.$t('global.lastMonth')}`,
        ...DateHelper.getLastMonthsPeriod(1),
      },
      {
        name: `${this.$t('global.lastThreeMonths')}`,
        ...DateHelper.getLastMonthsPeriod(3),
      },
      {
        name: `${this.$t('global.lastSixMonths')}`,
        ...DateHelper.getLastMonthsPeriod(6),
      },
      {
        name: `${this.$t('global.lastYear')}`,
        ...DateHelper.getLastYearsPeriod(1),
      },
      {
        name: `${this.$t('global.currentYear')}`,
        ...DateHelper.getCurrentYearPeriod(),
      },
    ];
  }

  private getClientIdFromRoute(): string {
    if (this.clientType === ClientTypeEnum.Prospect) {
      const currentRoute = this.routerService.route();
      return currentRoute.params && currentRoute.params.clientId;
    }
    return this.activeClient.cnpjCpf;
  }
}
